module.exports = __webpack_public_path__ + "img/Images_Firefox.3cadaa29.svg";